import Spinner from 'components/Common/Spinner/Spinner';
import React from 'react';
import styles from './ItemsLoadingSpinner.module.scss';

type OwnProps = {
  isLoading: boolean;
};

const ItemsLoadingSpinner = ({ isLoading }: OwnProps) => {
  if (!isLoading) return null;

  return (
    <div className={styles.itemsLoadingSpinner}>
      <Spinner />
    </div>
  );
};

export default ItemsLoadingSpinner;
